import { useEffect } from 'react';

import EnsureLoggedInContainer from '@/components/EnsureLoggedIn/EnsureLoggedInContainer';
import TaxCertCaptureForm from '@/components/TaxCertCaptureForm/TaxCertCaptureForm';
import { useGetQueryParams } from '@/hooks/queryParams/useGetQueryParams';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import {
    getBidderId,
    getDefaultAddressId,
    getUserAddressById,
    getUserData,
    getUserFullName,
    isUserDataLoaded,
} from '@/redux/modules/account/user/user.selectors';
import { fetchCertCaptureToken, getCertCaptureToken, getCertificateError } from '@/redux/modules/certCapture';
import { getDeployment } from '@/redux/modules/config';
import { CountriesWithISOCodes, USStatesWithISOCodes } from '@/utils/intl';
import { getTaxCertCaptureUrl } from '@/utils/urls';

const TaxCertCapturePage = () => {
    const bidderId = useAppSelector(getBidderId);
    const deployment = useAppSelector(getDeployment);
    const certCaptureToken = useAppSelector(getCertCaptureToken);
    const userData = useAppSelector(getUserData);
    const userDataLoaded = useAppSelector(isUserDataLoaded);
    const { shipZone } = useGetQueryParams()();
    const dispatch = useAppDispatch();
    const defaultAddressId = useAppSelector(getDefaultAddressId);
    const userDefaultAddress = useAppSelector((state) => getUserAddressById(state, defaultAddressId));
    const certificateError = useAppSelector(getCertificateError);
    const userFullName = useAppSelector(getUserFullName);
    const stateCode = USStatesWithISOCodes.find((s) => s.code === userData.state || s.name === userData.state);
    const countryCode = CountriesWithISOCodes.find((c) => c.code === userData.country || c.name === userData.country);
    const country = userData.country === 'USA' ? 'United States' : countryCode?.name;

    const address = userDefaultAddress?.address2
        ? `${userDefaultAddress?.address1} ${userDefaultAddress?.address2}`
        : userDefaultAddress?.address1;

    const user = {
        address: address,
        city: userData.city,
        country: country,
        email: userData.email,
        name: userFullName,
        phone: userData.mobileNumber,
        state: stateCode?.name,
        zip: userData.zip,
    };

    const certCaptureUrl = getTaxCertCaptureUrl(deployment, certCaptureToken, shipZone, user, bidderId);

    useEffect(() => {
        if (userDataLoaded) {
            dispatch(fetchCertCaptureToken());
        }
    }, [dispatch, userDataLoaded]);

    return (
        <EnsureLoggedInContainer>
            <TaxCertCaptureForm
                certCaptureUrl={certCaptureUrl}
                certificateError={certificateError}
            />
        </EnsureLoggedInContainer>
    );
};

export default TaxCertCapturePage;
